<template>
  <div>
    <div v-show="productVisible">
      <van-nav-bar
        :title="pageTitle"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
      <van-cell-group>
        <van-field placeholder="请输入文章名称" v-model="article.goods_name"/>
        <van-cell title="分类" :value="cateName" is-link @click="clickCategory"/>
        <van-actionsheet
          v-model="show"
          :actions="actions"
          @select="onSelect"
        />
        <van-cell title="文章内容" value="内容"  is-link @click="showDescription"/>
      </van-cell-group>
    </div>
    <div v-show="descriptionVisible">
      <van-nav-bar
        title="编辑商品详情"
        left-text="完成"
        left-arrow
        @click-left="onClickEdit"
      />
      <div id="article-body">
        <editor v-model="article.description" :init="editorInit" class="editor"></editor>
        <van-popup v-model="popupShow" class="popup">

          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="this.apiUrl+'/v1/upload/upload'"
            :headers="headers"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>

          <van-row>
            <van-button type="primary" class="btn-upload" @click="insertImage">插入图片</van-button>
          </van-row>

        </van-popup>
      </div>
    </div>

    <van-row class="btn-bottom">
      <van-col span="24"><van-button type="primary" @click="onClickSave">保存</van-button></van-col>
      <!--<van-col span="12"><van-button type="default">加入仓库</van-button></van-col>-->
    </van-row>

  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  import {NavBar,CellGroup,Cell,Field,Uploader,Icon,Row,Col,Button,Dialog,Popup,ActionSheet} from 'vant'

    export default {
        name: "create",
        components:{
            [NavBar.name]:NavBar,
            [CellGroup.name]:CellGroup,
            [Field.name]:Field,
            [Uploader.name]:Uploader,
            [Icon.name]:Icon,
            [Cell.name]:Cell,
            [Row.name]:Row,
            [Col.name]:Col,
            [Button.name]:Button,
            [Dialog.name]:Dialog,
            [Popup.name]:Popup,
            [ActionSheet.name]:ActionSheet,
            PopupPicker,
            Group,
            GroupTitle,
            'editor':Editor
        },
        data() {
            return {
                pageTitle:'',
                dialogImageUrl: '',
                dialogVisible: false,
                headers:{},
                descriptionVisible:false,
                productVisible:true,
                article:{},
                imgList:[],
                articleId:0,
                categoryList:[],
                categoryValue:[],
                editorInit:this.handleEditorInit(),
                popupShow:false,
                imageUrl:'',
                editor:{},
                actions:[],
                show:false,
                cateName:'请选择分类',
                cateId:0
            };
        },
        created(){
            this.headers.Authorization = 'Bearer ' + Cookies.get('access_token');
            var _this = this;
            this.articleId = this.$route.query.articleId;
            if (this.articleId){
                this.pageTitle = '编辑文章';
                this.$http.get('/v1/article/view?id='+this.articleId).then((res)=>{
                    _this.article = res.data
                })
            }else {
                this.pageTitle = '添加文章';
            }
        },
        methods:{
            uploadSuccess(res,file,fileList){
                if (res.errcode == 0){
                    this.imgList.push(res.imgUrl)
                }
            },
            onClickLeft(){
                this.$router.back()
            },
            onClickEdit(){
                this.productVisible = true
                this.descriptionVisible = false
            },
            onClickSave(){
                var _this = this;
                if (this.articleId){
                    this.$http.patch('/v1/site/article/update/id/'+this.articleId,this.article).then((res)=>{
                        if (res.data.errcode == 0) {
                            _this.$router.push('/mobile/product/list')
                        }
                    })
                }else{
                    this.article.site_id = Cookies.get('siteId');
                    this.$http.post('/v1/site/article/create',this.article).then((res)=>{
                        if (res.data.errcode == 0) {
                            _this.$router.push('/mobile/article/index')
                        }else {
                            Dialog.alert({
                                message:res.data.msg
                            })
                        }
                    })
                }

            },
            handleRemove(file, fileList) {
                var index = this.imgList.indexOf(file)
                if (index > -1){
                    this.imgList.splice(index,1);
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            showDescription(){
                this.productVisible = false
                this.descriptionVisible = true
                var _this = this;
                /*实例化一个编辑器*/
                /*var ue = UE.getEditor('article-body');
                UE.Editor.prototype._bkGetActionUrl = UE.Editor.prototype.getActionUrl;
                UE.Editor.prototype.getActionUrl = function(action) {
                    if (action == 'uploadimage' || action == 'uploadscrawl' || action == 'uploadimage') {
                        return 'http://a.b.com/upload.php';
                    } else if (action == 'uploadvideo') {
                        return 'http://a.b.com/video.php';
                    } else {
                        return this._bkGetActionUrl.call(this, action);
                    }
                }*/
            },
            images_upload_handle(blobInfo, success, failure){
                var formData;
                formData = new FormData();
                formData.append('file', blobInfo.blob(), fileName(blobInfo));
                this.$http.post('/v1/upload/upload',formData).then((res)=>{
                    if (res.data.errcode == 0){
                        success(res.data.msg);
                    }else{
                        failure(res.data.msg);
                    }
                });
            },
            handleEditorInit(){
                var _this = this;
                return {
                    language_url: '../../../../static/tinymce/langs/zh_CN.js',
                    language: 'zh_CN',
                    height: 300,
                    skin_url: '../../../../static/tinymce/skins/lightgray',
                    theme: 'modern',
                    //mobile: { theme: 'mobile' },
                    menubar: false,
                    plugins: [
                        'advlist autolink lists charmap preview anchor textcolor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime table contextmenu paste code help wordcount'
                    ],
                    toolbar: 'undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code | mybutton',
                    setup: function (editor) {
                        editor.addButton('mybutton', {
                            text: '插入图片',
                            icon: false,
                            onclick: function () {
                                _this.popupShow = true;
                                _this.editor = editor;
                                //editor.insertContent('&nbsp;<b>It\'s my button!</b>&nbsp;');
                            }
                        });
                    },
                    images_upload_handler:function (blobInfo, success, failure) {
                        console.log('aaaa');
                        //this.images_upload_handler(blobInfo,success,failure);
                    }
                }
            },
            beforeRead(){

            },
            handleAvatarSuccess(res, file) {
                //this.imageUrl = URL.createObjectURL(file.raw);
                this.imageUrl = res.imgUrl
            },
            insertImage(){
                this.editor.insertContent('<img src="'+this.imageUrl+'" />');
                this.popupShow = false;
            },
            onSelect(item){
                this.show = false;
                this.cateName = item.name;
                this.cateId = item.id;
            },
            clickCategory(){
                this.show = true;
                this.$http.get('/v1/nav/index',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                    var arr = [];
                    for (var i = 0;i<data.result.length;i++){
                      arr.push({name:data.result[i].title,id:data.result[i].nav_id});
                    }
                  this.actions = arr;
                })
            }
        }
    }
</script>

<style scoped>
  .upload-card{
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  .el-upload{
    margin:10px 0 0 0;
  }
  .el-upload>>> .el-upload--picture-card{
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  .el-upload>>> .el-upload-list--picture-card .el-upload-list__item{
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  .btn-bottom{
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    margin: 0 0 10px 0;
  }
  .van-button{
    width: 90%;
  }
  .select-category>>> .weui-cells{
    font-size: 14px !important;
  }
  .editor{
    width:99%;
  }
  .popup{
    width: 90%;
    padding:10px;
    text-align: center;
    z-index: 99999;
  }
  .popup-image{
    padding:20px 0;
    font-size:16px;
    line-height: 50px;
    height: 50px;
  }
  .btn-upload{
    width: 40%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

</style>
